/**
 * Cushion Cart Drawer v3 — Native Theme Drawer Edition
 * uscushion.com · 2026-07
 *
 * Listens for 'configurator:add-to-cart' from cushion-configurator.js.
 * Price is already calculated in the browser by the configurator.
 * This file rounds the price up to the nearest dollar, matches it to a
 * pre-created Shopify variant, calls /cart/add.js with Section Rendering,
 * then opens the theme's native mini-cart drawer (cart-notification).
 */
(function () {
  'use strict';

  /* ─── Source-product repair ───
     Chat widgets (tawk.to / Chaty) rewrite document.title to "1 new message"
     when a message pops. A shape's getLineProperties reads document.title at
     add-to-cart time, so if a customer clicks then, _Source Product arrives here
     as chat noise — which blurs which page (cover vs bench vs …) the order came
     from. We freeze the clean title at load and repair the property before send. */
  var INITIAL_TITLE = document.title;
  var TITLE_NOISE = /new message|nuevo mensaje|unread|^\(\d+\)\s/i;

  function cleanSourceName() {
    var clean = function (s) { return (s || '').split('–')[0].split('—')[0].trim(); };
    var t = clean(INITIAL_TITLE);
    if (!t || TITLE_NOISE.test(t)) {
      var og = document.querySelector('meta[property="og:title"]');
      t = clean(og && og.content);
    }
    return (t && !TITLE_NOISE.test(t)) ? t : window.location.pathname;
  }

  function repairSourceProduct(props) {
    if (!props) return props;
    var cur = props['_Source Product'];
    if (!cur || TITLE_NOISE.test(cur)) props['_Source Product'] = cleanSourceName();
    return props;
  }

  /* ─── Variant Pool Constants (EUR, depolster.de) ───
     2 segments cover €45–€1500, one variant per euro, stride 32768.
     Generated 2026-10-01 by depolster-pool-build.py. */
  var POOLS = [
    { min: 45,  max: 245,  firstId: 67557625463032, baseId: 67557625495800, basePrice: 46 },
    { min: 246, max: 1500, firstId: 67557632278776, baseId: 67557632311544, basePrice: 247 }
  ];
  var STRIDE = 32768;
  var PRICE_MIN = 45;
  var PRICE_MAX = 1500;

  var SECTIONS_TO_RENDER = ['mini-cart-drawer', 'cart-notification-count'];

  function getVariantId(price) {
    var rounded = Math.ceil(price);
    if (rounded < PRICE_MIN || rounded > PRICE_MAX) return null;
    for (var i = 0; i < POOLS.length; i++) {
      var p = POOLS[i];
      if (rounded >= p.min && rounded <= p.max) {
        if (rounded === p.min) return p.firstId;
        return p.baseId + (rounded - p.basePrice) * STRIDE;
      }
    }
    return null;
  }

  /* ─── UI helpers ─── */
  var addBtns = [];

  function injectSpinnerCSS() {
    if (document.getElementById('cc-spinner-css')) return;
    var style = document.createElement('style');
    style.id = 'cc-spinner-css';
    style.textContent =
      '@keyframes cc-spin{to{transform:rotate(360deg)}}' +
      '.cc-btn-spinner{display:inline-block;width:14px;height:14px;' +
      'border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;' +
      'border-radius:50%;animation:cc-spin .8s linear infinite;' +
      'vertical-align:middle;margin-right:8px}' +
      '.cc-btn-busy{position:relative;overflow:hidden}' +
      '.cc-btn-busy::after{content:"";position:absolute;top:0;left:-100%;' +
      'width:100%;height:100%;background:linear-gradient(90deg,' +
      'transparent,rgba(255,255,255,0.06),transparent);' +
      'animation:cc-shimmer 2s infinite}' +
      '@keyframes cc-shimmer{to{left:100%}}';
    document.head.appendChild(style);
  }

  function setBtnText(text) {
    addBtns.forEach(function (btn) {
      if (!btn) return;
      btn.innerHTML = '<span class="cc-btn-spinner"></span>' + text;
    });
  }

  function setBusy(busy) {
    addBtns.forEach(function (btn) {
      if (!btn) return;
      btn.disabled = busy;
      if (busy) {
        btn.dataset.prevText = btn.textContent;
        btn.classList.add('cc-btn-busy');
        setBtnText('Wird hinzugefügt …');
      } else {
        btn.classList.remove('cc-btn-busy');
        if (btn.dataset.prevText) {
          btn.textContent = btn.dataset.prevText;
          delete btn.dataset.prevText;
        }
      }
    });
  }

  function trackEvent(action, label) {
    if (typeof gtag === 'function') {
      gtag('event', action, { event_category: 'cushion_cart', event_label: label });
    }
  }

  /* ─── Open native theme drawer ─── */
  function openNativeDrawer(parsedState) {
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents(parsedState);
      return;
    }

    // Fallback: manually update drawer HTML and open
    var drawer = document.getElementById('mini-cart-drawer');
    if (drawer) {
      SECTIONS_TO_RENDER.forEach(function (id) {
        if (parsedState.sections && parsedState.sections[id]) {
          var target = document.getElementById(id);
          if (target) {
            var parsed = new DOMParser().parseFromString(parsedState.sections[id], 'text/html');
            var section = parsed.querySelector('.shopify-section');
            if (section) target.innerHTML = section.innerHTML;
          }
        }
      });
      drawer.classList.add('animate', 'active');
      document.body.classList.add('added__overlay');
    }
  }

  /* ─── Add to cart — /cart/add.js with Section Rendering ─── */
  function addToCart(data) {
    var finalPrice = data.price;
    var variantId = getVariantId(finalPrice);

    if (!variantId) {
      trackEvent('add_to_cart_fail', 'price_out_of_range_$' + finalPrice);
      window.alert('Diese Polstergröße liegt außerhalb des aktuell möglichen Preisbereichs (' + PRICE_MIN + ' €–' + PRICE_MAX + ' €). Bitte kontaktiere uns für ein Angebot.');
      return;
    }

    var roundedPrice = Math.ceil(finalPrice);

    setBusy(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: repairSourceProduct(data.properties),
        sections: SECTIONS_TO_RENDER,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        if (r.status === 422) {
          return r.json().catch(function () { return {}; }).then(function (err) {
            throw new Error((err && err.description) || 'Variant not available');
          });
        }
        throw new Error('Cart add failed: ' + r.status);
      })
      .then(function (parsedState) {
        trackEvent('add_to_cart_success', '$' + roundedPrice);
        openNativeDrawer(parsedState);
      })
      .catch(function (err) {
        console.error('CushionCartDrawer:', err);
        trackEvent('add_to_cart_fail', err.message);
        window.alert('Leider konnte der Artikel nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
      })
      .then(function () {
        setBusy(false);
        if (window.CushionConfigurator) window.CushionConfigurator.recalc();
        if (window.RoundCushionConfigurator) window.RoundCushionConfigurator.recalc();
        if (window.BayWindowConfigurator) window.BayWindowConfigurator.recalc();
        if (window.RVCushionConfigurator) window.RVCushionConfigurator.recalc();
        if (window.ChaiseCushionConfigurator) window.ChaiseCushionConfigurator.recalc();
      });
  }

  function init() {
    injectSpinnerCSS();
    addBtns = [document.getElementById('cc-add-btn'), document.getElementById('cc-add-btn-sticky')].filter(Boolean);

    document.addEventListener('configurator:add-to-cart', function (e) {
      addToCart(e.detail);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
